import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { InstanceProps, create } from 'react-modal-promise';

import Modal from 'components/Modal';
import IconButton from 'components/IconButton';
import { ButtonV3 } from 'components/ComponentV2';
import { useCandidate } from 'hooks/useCandidate';
import { PAGE_ROUTES } from 'lib/page-routes';

import styles from './DeleteAccountModal.module.scss';

const DeleteAccountModal: React.FC<InstanceProps<boolean | undefined>> = (
  props
) => {
  const { isOpen: open, onResolve, onReject } = props;
  const [tSettings] = useTranslation('candidate.settings');
  const [tCommon] = useTranslation('common');

  const router = useRouter();
  const { deleteCandidate } = useCandidate();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onDeleteAccount = async () => {
    setIsLoading(false);
    await deleteCandidate(() => {
      router.push(`${PAGE_ROUTES.LOGOUT}?type=candidate`);
      onResolve();
    });
    setIsLoading(true);
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={onReject}
      contentClassName={styles['delete-account-modal']}
    >
      <div className={styles.header}>
        <p>{tCommon('delete-account')}</p>
        <IconButton
          iconName="close"
          size="small"
          className={styles.close}
          onClick={() => onReject()}
        />
      </div>
      <div className={styles.content}>
        <p>{tSettings('delete-account-modal.description1')}</p>
        <br />
        <p>{tSettings('delete-account-modal.description2')}</p>
        <br />
        <p>{tSettings('delete-account-modal.description3')}</p>
      </div>
      <div className={styles.action}>
        <ButtonV3 color="black" variant="text" onClick={() => onReject()}>
          {tCommon('cancel')}
        </ButtonV3>
        <ButtonV3
          isLoading={isLoading}
          color="danger"
          onClick={onDeleteAccount}
        >
          {tSettings('delete-account-modal.confirm')}
        </ButtonV3>
      </div>
    </Modal>
  );
};

const DeleteAccountModalInstance = create(DeleteAccountModal);

export default DeleteAccountModalInstance;
